import { employeeService } from './employeeService';

export * from './employeeService';
export default employeeService;
